/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, take } from 'rxjs/operators';

import { UsuarioInterface } from '../interfaces/usuario.interface';
import { VendedorInterface } from '../interfaces/vendedor.interface';
import { ClienteInterface } from '../interfaces/clientes.interface';
import { SucursalInterface } from '../interfaces/sucursal.interface';

// Plugin storage
import { Storage } from '@ionic/storage-angular';
import { Platform, AlertController } from '@ionic/angular';


import { environment  } from '../../environments/environment';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProductosService } from './productos.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {


  //token:string;
  //id_usuario:string;

  vendedores:  VendedorInterface[] = [];
  clientes: ClienteInterface[] = [];
  sucursales: SucursalInterface[] = [];
  usuario: UsuarioInterface = {
            id_usuario: '',
            idQS:0,
            username:'',
            password:'',
            email: '',
            celular:'',
            companyID:0,
            token: '',
            idQS_Cliente: 0,
            tipoUsuario: 'C',
            descuento: 0,
            Posicion: 'PRECIO B'
        };

  logoCia = '';
  logoCiaLarge = '';
  nombreCia = '';

  private _ps = inject(ProductosService);
  constructor( private http: HttpClient,
               private storage: Storage,
               private platform: Platform,
               private router: Router,
               private alertCtrl: AlertController,
               private translate: TranslateService,
              
               ) {

    this.cargar_storage();
    this.cargar_vendedores();
    
    if (this.usuario.id_usuario) {
      this.reloadUsuario();
    } else {
      this._ps.cargar_todos('0');
    }

  }

  reloadUsuario() {
    const url = environment.urlServicios + '/login/' + this.usuario.id_usuario;
    
    this.http.get(url)
      .pipe(take(1))
      .subscribe(async (resp: any) => {
        if (resp.error) {
          const alerta = await this.alertCtrl.create({
            header: this.translate.instant('ERRORS.ERROR_CARGANDO_USUARIO'),
            message: resp.mensaje,
            buttons: ['OK']
          });
          await alerta.present();
        } else {

          this.usuario.token = resp.usuario.token;
          this.usuario.id_usuario = resp.usuario.id;
          this.usuario.email = resp.usuario.email ? resp.usuario.email : '';

          this.usuario.username = resp.usuario.username;

          this.usuario.idQS = resp.usuario.idQS;
          this.usuario.idQS_Cliente = resp.usuario.idQS_Cliente ? resp.usuario.idQS_Cliente : 0;
          this.usuario.tipoUsuario = resp.usuario.tipoUsuario ? resp.usuario.tipoUsuario : 'E';
          this.usuario.descuento = resp.usuario.descuento ? resp.usuario.descuento : 0;
          this.usuario.password = '';
          this.usuario.celular = resp.usuario.celular;
          this.usuario.companyID = resp.usuario.companyID;

          this.logoCia = resp.usuario.logocia;
          this.logoCiaLarge = resp.usuario.logocia_large;
          this.nombreCia = resp.usuario.Compania;
          
          this.usuario.Posicion = resp.usuario.Posicion ? resp.usuario.Posicion : 'PRECIO B';

          
          // Volver a cargar los clientes, las sucursales y los vendedores
          await this.cargar_clientes();
          this.cargar_sucursales();
          this.cargar_vendedores();
          
          this._ps.cargar_todos(this.usuario.id_usuario);

          // Guardar en el storage
          this.guardar_storage();
        }
      }, async error => {
        const mensaje = error.name === 'HttpErrorResponse' ? 
          this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : 
          error.message;
        const alerta = await this.alertCtrl.create({
          header: 'Error!!',
          message: mensaje,
          buttons: ['OK']
        });
        await alerta.present();
      });
      
    }

   

   activo(): boolean{
    /* if (this.usuario.token) {
      return true;
    } else {
      return false;
    } */
    return this.usuario.token ? true : false;

  }

  

  ingresar(usuario: string, clave: string){

    const data = {
      username: usuario,
      password: clave
    };

    const url = environment.urlServicios +  '/login';
    return this.http.post( url, data )
                   .pipe(
                    map( async (resp: any) =>{
                         if (resp.error) {

                          const alerta = await this.alertCtrl.create({
                            header: this.translate.instant('ERRORS.ERROR_EN_LOGIN'),
                            message: resp.Mensaje,
                            buttons: ['OK']
                          });
                          await alerta.present();

                          this.cerrar_sesion();

                        } else {

                          //console.log(resp.usuario);

                          this.usuario.token = resp.usuario.token;
                          this.usuario.id_usuario = resp.usuario.id;

                          this.usuario.email = resp.usuario.email ? resp.usuario.email : '';
                          this.usuario.username = resp.usuario.username;
                          this.usuario.idQS = resp.usuario.idQS;
                          this.usuario.idQS_Cliente = resp.usuario.idQS_Cliente ? resp.usuario.idQS_Cliente : 0;
                          this.usuario.tipoUsuario = resp.usuario.tipoUsuario ? resp.usuario.tipoUsuario : 'E';
                          this.usuario.descuento = resp.usuario.descuento ? resp.usuario.descuento : 0;
                          this.usuario.password = '';
                          this.usuario.celular = resp.usuario.celular;
                          this.usuario.companyID = resp.usuario.companyID;

                          this.logoCia = resp.usuario.logocia;
                          this.logoCiaLarge = resp.usuario.logocia_large;
                          this.nombreCia = resp.usuario.Compania;
                          
                          this.usuario.Posicion = resp.usuario.Posicion ? resp.usuario.Posicion : 'PRECIO B';
                          
                          // Volver a cargar los clientes, las sucursales y los vendedores
                          await this.cargar_clientes();
                          this.cargar_sucursales();
                          this.cargar_vendedores();
                          this._ps.cargar_todos(this.usuario.id_usuario);
                          
                          // Guardar en el storage
                          this.guardar_storage();

                        }

                   }));


  }

  cargar_sucursales() {
    const url = environment.urlServicios + '/pedidos/sucursales';
    this.http
      .get(url)
      .pipe(take(1))
      .subscribe(
        (resp: any) => {
          if (!resp.error) {
            this.sucursales = resp.Sucursales;
            // Si el tipo de usuario es 'C', filtrar solo esa sucursal
            if (this.usuario.tipoUsuario === 'C') {
              this.sucursales = this.sucursales.filter(sucursal => sucursal.idQS === this.usuario.companyID);
            }
          }
        },
        async (error) => {
          const mensaje =
            error.name === 'HttpErrorResponse'
              ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA')
              : error.message;
          const alerta = await this.alertCtrl.create({
            header: this.translate.instant('ERRORS.ERROR_CARGANDO_SUCURSALES'),
            message: mensaje,
            buttons: ['OK'],
          });
          await alerta.present();
        }
      );
  }


  async cargar_clientes() {
    const url = environment.urlServicios + '/clientes/clientes';
    try {
      const resp: any = await this.http.get(url).pipe(take(1)).toPromise();
      
      if (!resp.error) {
        this.clientes = resp.Clientes;
        // Si el tipo de usuario es 'C', filtrar solo ese cliente
        if (this.usuario.tipoUsuario === 'C') {
          this.clientes = this.clientes.filter(cliente => cliente.idQS === this.usuario.idQS);
        }
      }
    } catch (error) {
      const mensaje =
        error.name === 'HttpErrorResponse'
          ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA')
          : error.message;
      const alerta = await this.alertCtrl.create({
        header: this.translate.instant('ERRORS.ERROR_CARGANDO_CLIENTES'),
        message: mensaje,
        buttons: ['OK'],
      });
      await alerta.present();
    }
  }

  cerrar_sesion(){

    this.usuario.token = null;
    this.usuario.id_usuario = null;
    
    this.usuario.idQS = null;
    this.usuario.email = null;
    this.usuario.username = null;
    this.usuario.companyID = 0;
    this.usuario.tipoUsuario = 'C';
    this.usuario.descuento = 0;
    this.usuario.idQS_Cliente = 0;


    this.logoCia = '';
    this.logoCiaLarge = '';
    this.usuario.Posicion = 'PRECIO B';
    this.nombreCia = '';

    //Guardar storage
    this.guardar_storage();
    this.router.navigate(['/tabs/tab1']);

  }

  private guardar_storage(){

    if (this.platform.is('capacitor')) {
      //estamos en el dispositivo

      this.storage.set('idQS', this.usuario.idQS);

      this.storage.set('token', this.usuario.token);
      this.storage.set('id_usuario', this.usuario.id_usuario);
      this.storage.set('tipoUsuario', this.usuario.tipoUsuario);
      this.storage.set('email', this.usuario.email);
      this.storage.set('username', this.usuario.username);
      this.storage.set('companyID', this.usuario.companyID.toString());
      this.storage.set('Posicion', this.usuario.Posicion);
      this.storage.set('logoCia', this.logoCia);
      this.storage.set('logoCiaLarge', this.logoCiaLarge);
      this.storage.set('nombreCia', this.nombreCia);


    } else {
      //estamos en la computadora

      if (this.usuario.token) {
        localStorage.setItem('idQS', this.usuario.idQS.toString());

        localStorage.setItem('token', this.usuario.token);
        localStorage.setItem('id_usuario', this.usuario.id_usuario);
        localStorage.setItem('tipoUsuario', this.usuario.tipoUsuario);
        localStorage.setItem('email', this.usuario.email);
        localStorage.setItem('username', this.usuario.username);
        localStorage.setItem('companyID', this.usuario.companyID.toString());

        localStorage.setItem('logoCia', this.logoCia);
        localStorage.setItem('logoCiaLarge', this.logoCiaLarge);
        localStorage.setItem('nombreCia', this.nombreCia);
        localStorage.setItem('Posicion', this.usuario.Posicion);

      } else {
        localStorage.removeItem('idQS');
        localStorage.removeItem('token');
        localStorage.removeItem('id_usuario');
        localStorage.removeItem('tipoUsuario');
        localStorage.removeItem('email');
        localStorage.removeItem('username');
        localStorage.removeItem('companyID');

        localStorage.removeItem('logoCia');
        localStorage.removeItem('logoCiaLarge');
        localStorage.removeItem('nombreCia');
        localStorage.removeItem('Posicion');

      }
    }

  }


  cargar_storage(){

    const promesa = new Promise ((resolve, reject ) => {
      if (this.platform.is('capacitor')) {
        //estamos en el dispositivo

                    this.storage.get( 'token')
                            .then ( token => {
                              if (token){
                                this.usuario.token=token;
                              }
                            });

                    this.storage.get( 'id_usuario')
                            .then ( id_usuario => {
                              if (id_usuario){
                                this.usuario.id_usuario=id_usuario;
                              }
                            });

                    this.storage.get( 'idQS')
                            .then ( idQS => {
                              if (idQS){
                                this.usuario.idQS=idQS;
                              }
                            });

                    this.storage.get( 'tipoUsuario')
                            .then ( tipoUsuario => {
                              if (tipoUsuario){
                                this.usuario.tipoUsuario=tipoUsuario;
                              }
                            });

                    this.storage.get( 'email')
                            .then ( email => {
                              if (email){
                                this.usuario.email=email;
                              }
                            });

                    this.storage.get( 'Posicion')
                            .then ( Posicion => {
                              if (Posicion){
                                this.usuario.Posicion=Posicion;
                              }
                            });

                    this.storage.get( 'companyID')
                            .then ( companyID => {
                              if (companyID){
                                this.usuario.companyID=Number(companyID);
                              }
                            });

                    this.storage.get( 'logoCia')
                            .then ( logoCia => {
                              if (logoCia){
                                this.logoCia=logoCia;
                              }
                            });

                    this.storage.get( 'logoCiaLarge')
                            .then ( logoCiaLarge => {
                              if (logoCiaLarge){
                                this.logoCiaLarge=logoCiaLarge;
                              }
                            });

                    this.storage.get( 'nombreCia')
                            .then ( nombreCia => {
                              if (nombreCia){
                                this.nombreCia=nombreCia;
                              }
                            });

                    this.storage.get( 'username')
                            .then ( username => {
                              if (username){
                                this.usuario.username=username;
                              }
                              resolve(true);
                            });


      } else {
        //estamos en la computadora

        if (localStorage.getItem('token')) {

          //Hay un token en el localstorage
          this.usuario.token = localStorage.getItem('token');
          this.usuario.id_usuario = localStorage.getItem('id_usuario');
          this.usuario.idQS = Number(localStorage.getItem('idQS'));
          this.usuario.tipoUsuario = localStorage.getItem('tipoUsuario');
          this.usuario.email = localStorage.getItem('email');
          this.usuario.username = localStorage.getItem('username');
          this.usuario.companyID = Number(localStorage.getItem('companyID'));

          this.logoCia = localStorage.getItem('logoCia');
          this.logoCiaLarge = localStorage.getItem('logoCiaLarge');
          this.nombreCia = localStorage.getItem('nombreCia');
          
          this.usuario.Posicion = localStorage.getItem('Posicion') ? localStorage.getItem('Posicion') : 'PRECIO B';
          
        }

        resolve(true);


      }

    });


  }


  cargar_vendedores(){

    const url = environment.urlServicios + "/empleados/vendedores";

    this.http.get(url)
          .pipe(take(1)).subscribe( async (data: any) => {

                if (data.error) {

                  const alerta = await this.alertCtrl.create({
                    header: this.translate.instant('ERRORS.ERROR_CARGANDO_VENDEDORES'),
                    message: data.mensaje,
                    buttons: ['OK']
                  });
                  await alerta.present();

                } else {
                  this.vendedores = data.Vendedores;
                  if (this.usuario.tipoUsuario === 'C'){
                    this.vendedores = this.vendedores.filter(vendedor => vendedor.idQS === 2); //2 es el vendedor por defecto
                  }
                  
                }

               }, async error => {

                const mensaje = error.name === 'HttpErrorResponse' ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : error.message;
                const alerta = await this.alertCtrl.create({
                  header: 'Error!!',
                  message: mensaje,
                  buttons: ['OK']
                });
                await alerta.present();
               });

}







}
